import React from 'react';
import styled from 'styled-components';

type TableRowCountProps = {
  text: string;
};

export function TableRowCount({ text }: TableRowCountProps) {
  return <CountLabel>{text}</CountLabel>;
}

const CountLabel = styled('div')(({ theme }) => ({
  gridArea: 'row-counts',
  alignSelf: 'left',
  marginLeft: 16,
  color: theme.palette.neutral.main,
  ...theme.typography.label1,
}));
